<template>
  <div class="opera-meetingdetail">
    <topNav :title="$t('meetingDetail_title')" url="/opera/meetingOrder"></topNav>
    <div class="cityTop">
      <p class="left">{{$t('meetingDetail_orderNo')}}:<span>{{$route.params.id}}</span></p>
      <p class="right">{{$t('meetingDetail_totalFee')}}:<span>￥{{totalRate}}</span></p>
    </div>
    <mt-swipe :auto="0">
      <mt-swipe-item v-for="(item,key) in msgInfo" :key="item.catNo">

        <div class="content">
          <div class="topright">
            {{key+1}}/{{msgInfo.length}}
          </div>
          <div class="infos">
            <div class="title"><i class="iconfont icon-changfangxingbiaoqian"></i>{{$t('meetingDetail_placeInfo')}}</div>
            <ul class="list clearfix">
              <li class="info">{{$t('meetingDetail_catNo')}}:<span>{{item.catNo}}</span></li>
              <li class="info">{{$t('meetingDetail_categoryCode')}}:<span>{{item.category}}</span></li>
              <li class="info">{{$t('meetingDetail_theme')}}:<span>{{item.theme}}</span></li>
              <li class="info">{{$t('meetingDetail_sta')}}:<span>{{item.stas}}</span></li>
              <li class="info">{{$t('meetingDetail_placeDes')}}:<span>{{item.cateringPlaceDescript}}</span></li>
              <li class="info">{{$t('meetingDetail_board')}}:<span>{{item.board}}</span></li>
              <li class="info last" style="height:auto">{{$t('meetingDetail_remark')}}:<span>{{item.remark}}</span></li>
              <li class="line"></li>
            </ul>
          </div>
          <div class="infos ">
            <div class="title"><i class="iconfont icon-changfangxingbiaoqian"></i>{{$t('meetingDetail_orderInfo')}}</div>
            <ul class="list clearfix">
              <li class="info">{{$t('meetingDetail_rsvName')}}: <span>{{item.rsvName}}</span></li>
              <li class="info twocol">{{$t('meetingDetail_tables')}}:<span>{{item.tables}}</span></li>
              <li class="info twocol">{{$t('meetingDetail_dateBegin')}}: <span>{{item.dateBegin | datefomate}} </span></li>
              <li class="info twocol">{{$t('meetingDetail_peopleNumber')}}: <span>{{item.peopleNumber}}</span></li>
              <li class="info twocol">{{$t('meetingDetail_dateEnd')}}:<span>{{item.dateEnd |datefomate}} </span></li>
              <li class="info twocol">{{$t('meetingDetail_linkMan')}}: <span>{{item.linkMan}}</span></li>
              <li class="info twocol">{{$t('meetingDetail_tel')}}:<span><a :href='"tel:"+item.phone'>{{item.phone}}</a></span></li>
              <li class="info">{{$t('meetingDetail_salesman')}}:<span>{{item.salesmanDescript}}</span></li>
              <li class="info">{{$t('meetingDetail_company')}}: <span>{{item.companyName}}</span></li>
              <li class="info twocol">{{$t('meetingDetail_rate')}}:<span>￥{{item.rate}}</span></li>
              <li class="info twocol">{{$t('meetingDetail_comRate')}}:<span>￥{{item.comRate}}</span></li>
              <li class="line"></li>
            </ul>
          </div>
          <div class="infos ">
            <div class="title"><i class="iconfont icon-changfangxingbiaoqian"></i>{{$t('meetingDetail_other')}}</div>
            <ul class="list clearfix">
              <li class="info">{{$t('meetingDetail_createDate')}}: <span>{{item.createDateTime |datefomate2}}</span></li>
              <li class="info">{{$t('meetingDetail_modifyDate')}}: <span>{{item.modifyDateTime |datefomate2}}</span></li>
            </ul>
          </div>
        </div>
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>
<script>
  import footNav from '../operaCommon/footNav'
  import moment from 'moment'
  import _ from 'lodash'
  import {Swipe, SwipeItem} from 'mint-ui';

  export default {
    data() {
      return {
        msgInfo: [],
        totalRate: 0,

      }
    },
    mounted() {
      this.$http.get('/mobilepmsapi/reception/cateringDetail/' + this.$route.params.id).then(res => {
        if (res.data.result == 0) {
          this.msgInfo = res.data.retVal;
          _.forEach(this.msgInfo, (n, key) => {
            this.totalRate += _.add(n.rate, n.comRate);
          });
        }
      })
    },
    methods: {},
    filters: {
      datefomate(value) {
        return moment(value, "YYYY-MM-DD HH:mm:ss").format('MM/DD HH:mm')
      },
      datefomate2(value) {
        return moment(value, "YYYY-MM-DD HH:mm:ss").format('YYYY/MM/DD HH:mm:ss')
      }
    },

    components: {
      footNav
    }
  }
</script>
<style lang='less'>
  .opera-meetingdetail {
    background-color: #F6F8F9;

    .cityTop {
      margin: 0 20px;
      height: 15px;
      color: #333;
      margin-top: 12px;

      .left {
        float: left;

        span {
          margin-left: 5px;
        }
      }

      .right {
        float: right;

        span {
          margin-left: 5px;
          color: #d0011b;
        }
      }
    }

    .mint-swipe {
      height: 550px;

      .content {
        box-shadow: 0 0 11px 0 #999;
        padding: 10px 0;
        border-radius: 3px;
        width: 96%;
        background-color: #fff;
        margin: 0 auto;
        margin-top: 15px;
        position: relative;

        .topright {
          position: absolute;
          right: 0;
          top: 0;
          border-radius: 0 3px 0 8px;
          width: 46px;
          height: 21px;
          color: #fff;
          background-color: #333;
          line-height: 21px;
          text-align: center;
        }

        .infos {
          .title {
            padding-left: 18px;
            color: #000;
            position: relative;
            height: 20px;
            line-height: 20px;

            .iconfont {
              position: absolute;
              left: -6px;
              top: 0px;
              color: #F69C2D;
              margin: 0;
            }
          }
        }

        .list {
          padding: 10px 20px;

          .info {
            width: 100%;
            float: left;
            height: 20px;
            line-height: 20px;
            color: #333;

            span {
              margin-left: 5px;

              a {
                color: #000;
              }
            }

            &.twocol {
              width: 50%;
            }
          }

          .line {
            width: 100%;
            float: left;
            height: 10px;
            border-bottom: 1px dashed #ccc;
          }
        }
      }

      .mint-swipe-indicators {
        .is-active {
          background: #000;
          opacity: .7;
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// meetingDetail.vue?7729423e